import React, { useState } from 'react';
import { getGameByCode } from '../gameEngine';

export default function JoinGame({ navigate }) {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleJoin = async () => {
    if (code.trim().length < 6) {
      setError('Please enter a valid 6-character game code.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const game = await getGameByCode(code.trim());
      navigate('spectator', game);
    } catch (e) {
      setError('Game not found. Check the code and try again.');
      setLoading(false);
    }
  };

  return (
    <div className="screen">
      <div className="header">
        <button className="header-back" onClick={() => navigate('home')}>‹</button>
        <span className="header-title">Join Game</span>
      </div>

      <div style={{ padding: '40px 24px', display: 'flex', flexDirection: 'column', gap: 24 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>👁</div>
          <div style={{ fontSize: 16, color: 'var(--gray)', lineHeight: 1.6 }}>
            Enter the 6-character game code from the scorekeeper to follow along live.
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Game Code</label>
          <input
            className="form-input form-input-code"
            placeholder="ABC123"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase().slice(0, 6))}
            maxLength={6}
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck={false}
          />
        </div>

        {error && (
          <div style={{ background: '#2a0a0a', border: '2px solid #5a1a1a', borderRadius: 'var(--radius-sm)', padding: '12px 16px', color: 'var(--red)', fontSize: 14, textAlign: 'center' }}>
            {error}
          </div>
        )}

        <button className="btn btn-primary btn-lg" onClick={handleJoin} disabled={loading || code.length < 6}>
          {loading ? 'Finding Game...' : 'Join Game →'}
        </button>
      </div>
    </div>
  );
}
